import { View } from "extensions/marionette";
import { _ } from "extensions/underscore";

import { Loader } from "common/components/loader";

import summaryTemplate from "./summary.jst";
import totalsTemplate from "./totalsTemplate.jst";

export const SummaryBar = View.extend({
    template: summaryTemplate,
    className: "summary-bar",
    ui: {
        totals: ".totals-cont"
    },
    renderTotals() {
        const totals = this.getOption("totals");

        const _render = (data) => {
            this.ui.totals.html(totalsTemplate({
                totals: _(data).map(function(t) {
                    if (t.valueType === "count") {
                        t.formattedValue = this.formatNumber(t.value);
                    } else if (t.valueType === "rate") {
                        t.formattedValue = t.value;
                    } else {
                        t.formattedValue = this.formatAmountWithCurrentCurrency(t.value);
                    }
                    return t;
                }, this)
            }));
        };

        if (totals instanceof Promise) {
            Loader.addTo(this.ui.totals);
            this.totalsPromise = totals.then((totalsData) => {
                Loader.removeFrom(this.ui.totals);
                _render(totalsData);
            });
        } else {
            _render(totals);
        }
    },

    onRender() {
        this.renderTotals();
    },

    onDestroy() {
        if (this.totalsPromise) {
            this.totalsPromise.cancel();
        }
    }
});
